import { render, staticRenderFns } from "./CpuFunctionAddOrEditModal.vue?vue&type=template&id=2cc453b7&scoped=true"
import script from "./CpuFunctionAddOrEditModal.vue?vue&type=script&lang=js"
export * from "./CpuFunctionAddOrEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc453b7",
  null
  
)

export default component.exports